import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function AboutHero() {
  const [showMethod, setShowMethod] = useState(false);

  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden bg-[#F8F5F0]">
      {/* Decorative background shapes */}
      <div className="absolute top-0 right-0 w-[55%] h-full hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20professional%20asian%20male%20insurance%20advisor%20sitting%20at%20desk%20with%20natural%20window%20light%20soft%20bokeh%20background%20calm%20trustworthy%20expression%20modern%20minimalist%20office%20interior&width=900&height=900&seq=abouthero2001&orientation=squarish"
          alt="陳琮恩 保險建築師"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F8F5F0] via-[#F8F5F0]/60 to-transparent"></div>
      </div>

      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]"
        style={{ backgroundImage: 'repeating-linear-gradient(45deg, #5C5470 0, #5C5470 1px, transparent 0, transparent 50%)', backgroundSize: '20px 20px' }}>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-20">
        <div className="max-w-xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#5C5470]/10 border border-[#5C5470]/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-[#D4A373]"></span>
            <span className="text-[#5C5470] font-medium" style={{ fontSize: '1rem' }}>保險建築師 · 陳琮恩</span>
          </div>

          {/* H1 */}
          <h1
            className="font-serif font-bold text-[#5C5470] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', lineHeight: '1.3' }}
          >
            關於琮恩
            <br />
            <span className="text-[#D4A373]">用傾聽，為人生</span>
            <br />
            設計安全藍圖
          </h1>

          {/* Subtitle */}
          <p
            className="text-[#5C5470]/80 mb-10 border-l-4 border-[#D4A373] pl-5"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            當您說「最近有點累」，我聽見的不是保單，
            <br className="hidden sm:block" />
            而是您需要的安全感。
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-calendar-check-line"></i>
              預約一對一諮詢
            </Link>
            <button
              onClick={() => {
                setShowMethod(true);
                setTimeout(() => {
                  document.getElementById('method-section')?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
              }}
              className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200 cursor-pointer"
              style={{ fontSize: '1.1875rem' }}
            >
              了解我的方法
              <i className="ri-arrow-down-line"></i>
            </button>
          </div>

          {/* Mobile photo */}
          <div className="mt-12 lg:hidden rounded-2xl overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20professional%20asian%20male%20insurance%20advisor%20sitting%20at%20desk%20with%20natural%20window%20light%20soft%20bokeh%20background%20calm%20trustworthy%20expression%20modern%20minimalist%20office%20interior&width=800&height=600&seq=abouthero2002&orientation=landscape"
              alt="陳琮恩 保險建築師"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
